import { render, staticRenderFns } from "./consumerManagement.vue?vue&type=template&id=8f954060&scoped=true"
import script from "./consumerManagement.vue?vue&type=script&lang=ts"
export * from "./consumerManagement.vue?vue&type=script&lang=ts"
import style0 from "./consumerManagement.vue?vue&type=style&index=0&id=8f954060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f954060",
  null
  
)

export default component.exports